// extracted by mini-css-extract-plugin
export var typingIndicator = "_mv-0";